<ng-container *ngTemplateOutlet="fieldsTemplate; context: {fields: fields}"></ng-container>
<ng-template #fieldsTemplate let-fields="fields" let-showField="showField">
    <div *ngFor="let field of fields"
         class="mx-dynamic-field mx-dynamic-field_{{field.type}} {{layoutClass}} {{fieldConfigs.get(field.name)?.style}}"
         [id]="field.name"
         [ngClass]="{'hidden': customizer.showOriginal(field.name) && field.hidden}">
        <ng-container *ngIf="customizer.hasBefore(field.name)">
            <ng-container
                    *ngTemplateOutlet="customizer.getBefore(field.name); context: {name:field.name,field:field,form:form,control:form.controls[field.name]}">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="customizer.showOriginal(field.name); else elseBlock">
            <ng-container [ngSwitch]="field.type">
                <mx-text-field *ngSwitchCase="'textbox'"
                               [form]="form"
                               [hidden]="field.hidden"
                               [label]="field.label"
                               [name]="field.name"
                               [errorMessage]="errorMessage"
                               [formReadonlyMode]="readonlyMode"
                               [fieldConfig]="fieldConfigs.get(field.name)"
                ></mx-text-field>
                <mx-text-area-field *ngSwitchCase="'textarea'"
                                    [form]="form"
                                    [hidden]="field.hidden"
                                    [label]="field.label"
                                    [name]="field.name"
                                    [errorMessage]="errorMessage"
                                    [formReadonlyMode]="readonlyMode"
                ></mx-text-area-field>
                <mx-html-field *ngSwitchCase="'htmlbox'"
                               [form]="form"
                               [hidden]="field.hidden"
                               [label]="field.label"
                               [name]="field.name"
                               [errorMessage]="errorMessage"
                               [formReadonlyMode]="readonlyMode"
                ></mx-html-field>
                <mx-numeric-field *ngSwitchCase="'numeric'"
                                  [form]="form"
                                  [hidden]="field.hidden"
                                  [label]="field.label"
                                  [name]="field.name"
                                  [validation]="field.validation"
                                  [positiveInteger]="field.positiveInteger"
                                  [errorMessage]="errorMessage"
                                  [formReadonlyMode]="readonlyMode"
                                  [fieldConfig]="fieldConfigs.get(field.name)"
                ></mx-numeric-field>
                <mx-combo-box-field *ngSwitchCase="'dropdown'"
                                    [form]="form"
                                    [hidden]="field.hidden"
                                    [label]="field.label"
                                    [name]="field.name"
                                    [options]="field.options"
                                    [errorMessage]="errorMessage"
                                    [disabledDependsOnField]="field.disabledDependsOnField"
                                    [dependsOn]="field.dependsOn"
                                    [formReadonlyMode]="readonlyMode"
                                    [fieldConfig]="fieldConfigs.get(field.name)"
                ></mx-combo-box-field>
                <mx-color-picker *ngSwitchCase="'colorpicker'"
                                [form]="form"
                                [hidden]="field.hidden"
                                [label]="field.label"
                                [name]="field.name"
                                [defaultColor]="field.defaultValue"
                                [errorMessage]="errorMessage"
                                [formReadonlyMode]="readonlyMode"
                                [fieldConfig]="fieldConfigs.get(field.name)"
                ></mx-color-picker>
                <mx-date-picker *ngSwitchCase="'datepicker'"
                                [form]="form"
                                [hidden]="field.hidden"
                                [label]="field.label"
                                [name]="field.name"
                                [errorMessage]="errorMessage"
                                [minDate]="field.minDate"
                                [maxDate]="field.maxDate"
                                [formReadonlyMode]="readonlyMode"
                                [fieldConfig]="fieldConfigs.get(field.name)"
                ></mx-date-picker>
                <mx-date-time-field *ngSwitchCase="'datetime'"
                                    [form]="form"
                                    [hidden]="field.hidden"
                                    [label]="field.label"
                                    [name]="field.name"
                                    [errorMessage]="errorMessage"
                                    [minDate]="field.minDate"
                                    [maxDate]="field.maxDate"
                                    [formReadonlyMode]="readonlyMode"
                                    [fieldConfig]="fieldConfigs.get(field.name)"
                ></mx-date-time-field>
                <mx-file-upload-field *ngSwitchCase="'fileupload'"
                                      [form]="form"
                                      [hidden]="field.hidden"
                                      [label]="field.label"
                                      [name]="field.name"
                                      [errorMessage]="errorMessage"
                                      [types]="field.allowedTypes"
                                      [formReadonlyMode]="readonlyMode"
                ></mx-file-upload-field>
                <mx-check-box-field *ngSwitchCase="'checkbox'"
                                    [form]="form"
                                    [hidden]="field.hidden"
                                    [label]="field.label"
                                    [name]="field.name"
                                    [informationKey]="field.informationKey"
                                    [unshielded]="field.unshielded"
                                    [errorMessage]="errorMessage"
                                    [formReadonlyMode]="readonlyMode">
                </mx-check-box-field>
                <mx-password-field *ngSwitchCase="'password'"
                                   [form]="form"
                                   [hidden]="field.hidden"
                                   [label]="field.label"
                                   [retypeLabel]="field.retypeLabel"
                                   [name]="field.name"
                                   [errorMessage]="errorMessage"
                                   [formReadonlyMode]="readonlyMode">
                </mx-password-field>
                <mx-assignment-field *ngSwitchCase="'assignmentgrid'"
                                     [form]="form"
                                     [hidden]="field.hidden"
                                     [label]="field.label"
                                     [name]="field.name"
                                     [errorMessage]="errorMessage"
                                     [componentName]="field.assignmentComponent"
                                     [selectionMode]="field.selectionMode"
                                     [formReadonlyMode]="readonlyMode"
                                     [fieldConfig]="fieldConfigs.get(field.name)">
                </mx-assignment-field>
                <mx-field-set class="mxs-expansion dynamic-form-set"
                              *ngSwitchCase="'fieldset'"
                              [form]="form"
                              [hidden]="field.hidden"
                              [label]="field.label"
                              [collapsible]="field.collapsible"
                              [collapsed]="field.collapsed"
                              [sublist]="field.sublist"
                              [errorMessage]="errorMessage"
                              [formReadonlyMode]="readonlyMode"
                              [fieldConfigs]="fieldConfigs">
                </mx-field-set>
                <mx-date-range *ngSwitchCase="'daterange'"
                               [form]="form"
                               [hidden]="field.hidden"
                               [label]="field.label"
                               [errorMessage]="errorMessage"
                               [fieldName]="field.name"
                               [dateRangeParams]="field.sublist"
                               [dateSelected]="field.value"
                               [formReadonlyMode]="readonlyMode"
                               [fieldConfig]="fieldConfigs.get(field.name)"
                >
                </mx-date-range>
                <ng-container *ngSwitchCase="'group'">
                    <ng-container *ngIf="showField === undefined || showField === field.name">
                        <ng-container *ngTemplateOutlet="fieldsTemplate;
                         context: {fields: field.sublist, showField: showChild(field) | async}"></ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-template #elseBlock
                     *ngTemplateOutlet="customizer.getReplacement(field.name); context: {name:field.name,field:field,form:form,control:form.controls[field.name]}">
        </ng-template>


        <ng-container *ngIf="customizer.hasAfter(field.name)">
            <ng-container
                    *ngTemplateOutlet="customizer.getAfter(field.name); context: {name:field.name,field:field,form:form,control:form.controls[field.name]}">
            </ng-container>
        </ng-container>
    </div>
</ng-template>
<ng-content class="mx-form-footer"
            select="mx-form-footer">
</ng-content>
